module.exports = __webpack_public_path__ + "img/company_intro3.baae067a.jpg";